import { actionCreatorFactory } from 'typescript-fsa';
import { IGridDataHandlers } from '@cbridge-utils/datagrid';
import { IApiErrorParams } from '@cbridge-packages/api';
import { IResolverMeta } from '@cbridge-utils/redux-observable';
import {
  ISourceSymbol,
  ISyntheticSymbol,
  ISyntheticSymbolDetails,
  ISyntheticSymbolForm,
  ISyntheticSymbolList,
  ISyntheticSymbolListKey,
  ISyntheticSymbolUpdate,
} from './symbolSynthetic.interface';

export namespace SymbolSyntheticAction {
  const actionCreator = actionCreatorFactory('SymbolSynthetic');

  export const reload = actionCreator('RELOAD');

  export const load = actionCreator.async<{ symbolId: ISyntheticSymbol['symbolId'] }, ISyntheticSymbolDetails, IApiErrorParams>('LOAD');
  export const loadList = actionCreator.async<ISyntheticSymbolListKey & IGridDataHandlers, ISyntheticSymbolList, IApiErrorParams>('LOAD_LIST');
  export const loadSourceSymbols = actionCreator.async<void, ISourceSymbol[], IApiErrorParams>('LOAD_SOURCE_SYMBOLS');

  interface ISyntheticSymbolCreateParams extends ISyntheticSymbolForm, Pick<IResolverMeta, 'reject'> {
  }

  interface ISyntheticSymbolUpdateParams extends ISyntheticSymbolUpdate, IResolverMeta {
  }

  export const create = actionCreator.async<ISyntheticSymbolCreateParams, { symbolId: ISyntheticSymbol['symbolId'] }, IApiErrorParams>('CREATE');
  export const update = actionCreator.async<ISyntheticSymbolUpdateParams, void, IApiErrorParams>('UPDATE');
  export const remove = actionCreator.async<{ symbolId: ISyntheticSymbol['symbolId'] }, void, IApiErrorParams>('REMOVE');

  export const processing = actionCreator.async<void, void, void>('PROCESSING');

  export const exportFile = actionCreator.async<
    Pick<ISyntheticSymbolListKey, 'symbolGroup' | 'search' | 'sort'>, void, IApiErrorParams
  >('EXPORT_FILE');

  export const destroy = actionCreator('DESTROY');
}
